// removed by extract-text-webpack-plugin
module.exports = {"container":"_1TuqCJYP3","grid":"QlEANWf1P _3ugGu5boG"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/grid/grid-left-header/grid-left-header.css
 ** module id = 2132
 ** module chunks = 0
 **/